import React from 'react'
import { View, SafeAreaView, StatusBar } from 'react-native'
import PropTypes from 'prop-types'

import Topbar from './Topbar'
import { useMainContainerStyles as useStyles } from './styles'
import { usePlatforms } from '../../../hooks/usePlatforms'
import { useTheme } from '../../../theming/ThemeProvider'

const MainContainer = ({ children, title }) => {
  const { isTablet } = usePlatforms()
  const { theme } = useTheme()
  const styles = useStyles(theme)

  return (
    <View style={{ flex: 1, overflowX: 'hidden' }}>
      <SafeAreaView />
      <StatusBar />
      {/* {Platform.OS === 'web' && (
        <View style={styles.alertMessage}>
          <Txt
            color='WHITE_TEXT'
            text="Due to schedule maintenance, Edge Capacity services won't be available from Sunday afternoon to Monday morning"
            identity={isTablet ? 'body1Bold' : 'body3Bold'}
            style={{ textAlign: 'center' }}
          />
        </View>
      )} */}
      <View style={{
        flex: 1,
        paddingHorizontal: isTablet ? 20 : 0

      }}
      >
        <View style={styles.container}>
          <Topbar
            title={title}
            display={!isTablet}
          />
          <View
            style={styles.content}
          >
            {children}
          </View>
        </View>
      </View>
    </View>
  )
}

MainContainer.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string.isRequired
}

export default MainContainer
